import React, { useState } from 'react';

function InstallAppPage({ title, appUrl, installPageUrl }) {
  const [copied, setCopied] = useState(false);
  const [pageCopied, setPageCopied] = useState(false);
  const qrSrc = `https://mabat.communityltd.co.il/api/portal/generic-qr?url=${encodeURIComponent(appUrl)}`;

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6f8', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: 'Heebo, Arial, sans-serif', direction: 'rtl' }}>
      <div style={{ width: '100%', maxWidth: 760, background: 'white', borderRadius: 20, boxShadow: '0 4px 24px rgba(0,0,0,0.08)', padding: '32px 28px' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 12, marginBottom: 6 }}>
          <div style={{ width: 44, height: 44, borderRadius: 12, background: '#eef2ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem' }}>📱</div>
          <div style={{ fontWeight: 800, fontSize: '1.3rem', color: '#1f2937' }}>{title}</div>
        </div>
        <div style={{ textAlign: 'center', color: '#6b7280', fontSize: '0.9rem', marginBottom: 28 }}>גישה מהירה לפורטל ישירות ממסך הבית</div>

        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap', justifyContent: 'center' }}>
          <div style={{ flex: '1 1 300px', maxWidth: 320, border: '1px solid #eef1f5', borderRadius: 16, padding: 24, textAlign: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 4 }}>
              <span style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1f2937' }}>התקנה באייפון</span>
              <span style={{ fontSize: '1.3rem' }}></span>
            </div>
            <div style={{ color: '#9ca3af', fontSize: '0.8rem', marginBottom: 16 }}>באמצעות Safari</div>
            <img src={qrSrc} alt="QR" style={{ width: 180, height: 180, borderRadius: 12 }} />
            <div style={{ color: '#9ca3af', fontSize: '0.78rem', marginTop: 14 }}>סרקו וכפתחו את הקישור ב־Safari</div>
            <div style={{ color: '#6b7280', fontSize: '0.78rem', marginTop: 10, lineHeight: 1.7 }}>
              1. לחצו על כפתור השיתוף (⬆️) בתחתית המסך<br />
              2. בחרו "הוסף למסך הבית"<br />
              3. לחצו "הוסף"
            </div>
          </div>

          <div style={{ flex: '1 1 300px', maxWidth: 320, border: '1px solid #eef1f5', borderRadius: 16, padding: 24, textAlign: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, marginBottom: 4 }}>
              <span style={{ fontWeight: 700, fontSize: '1.05rem', color: '#1f2937' }}>התקנה באנדרואיד</span>
              <span style={{ fontSize: '1.3rem' }}>🤖</span>
            </div>
            <div style={{ color: '#9ca3af', fontSize: '0.8rem', marginBottom: 16 }}>באמצעות Google Chrome</div>
            <img src={qrSrc} alt="QR" style={{ width: 180, height: 180, borderRadius: 12 }} />
            <div style={{ color: '#9ca3af', fontSize: '0.78rem', marginTop: 14 }}>סרקו באמצעות מצלמת אנדרואיד</div>
            <div style={{ color: '#6b7280', fontSize: '0.78rem', marginTop: 10, lineHeight: 1.7 }}>
              1. פתחו את הקישור ב־Chrome<br />
              2. לחצו על התפריט (⋮) בפינה<br />
              3. בחרו "התקנה ויצירת קיצור דרך" (או "התקן אפליקציה" / "הוסף למסך הבית", בהתאם לגרסת Chrome) ואז "התקנה"
            </div>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10 }}>
          <a href={appUrl} target="_blank" rel="noreferrer"
            style={{ background: '#1F8A8C', color: 'white', border: 'none', borderRadius: 10, padding: '10px 22px', fontSize: '0.9rem', fontWeight: 600, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6, textDecoration: 'none' }}>
            🔗 פתיחת הפורטל בקישור (בלי סריקה)
          </a>
          {/* אין מצלמה? לשלוח למישהו את הקישור לעמוד הזה — כשילחצו עליו הם
              יראו את אותן הוראות התקנה ישירות בטלפון שלהם. */}
          <button onClick={() => { navigator.clipboard.writeText(installPageUrl); setPageCopied(true); setTimeout(() => setPageCopied(false), 2000); }}
            style={{ background: pageCopied ? '#f0fdf4' : '#f8fafc', color: pageCopied ? '#15803d' : '#374151', border: '1px solid #e5e7eb', borderRadius: 10, padding: '8px 18px', fontSize: '0.85rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            📤 {pageCopied ? 'הקישור הועתק — שלחו אותו למי שאין לו מצלמה' : 'שיתוף עמוד ההתקנה (לשליחה למישהו)'}
          </button>
          <button onClick={() => { navigator.clipboard.writeText(appUrl); setCopied(true); setTimeout(() => setCopied(false), 2000); }}
            style={{ background: 'none', color: '#9ca3af', border: 'none', fontSize: '0.78rem', cursor: 'pointer', textDecoration: 'underline' }}>
            {copied ? '✓ הועתק' : 'העתקת קישור ישיר לפורטל בלבד'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function InstallApp() {
  return <InstallAppPage title="התקנת אפליקציית הניהול" appUrl="https://mabat.communityltd.co.il/projects" installPageUrl="https://mabat.communityltd.co.il/install-app" />;
}

export function InstallAppTenant() {
  return <InstallAppPage title="התקנת אפליקציית הדיירים" appUrl="https://mabat.communityltd.co.il/portal" installPageUrl="https://mabat.communityltd.co.il/install-app-tenant" />;
}
